// extracted by mini-css-extract-plugin
export default {"tertiaryButton":"tertiary-button_tertiaryButton__WhTDg"};